export class DownloadFile {
  static base64ToBlob(base64, type) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type: type });
  }

  static downloadBase64File(base64File, name, type) {
    const url = URL.createObjectURL(this.base64ToBlob(base64File, type));
    this.downloadFile(url, name);
  }

  static downloadBase64FileWithHeaders(
    base64File,
    type,
    headers,
    fallbackFileName,
    fileExtension = ""
  ) {
    let fileName = fallbackFileName || "download";
    if (headers && headers["content-disposition"]) {
      const contentDisposition = headers["content-disposition"];
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (filenameMatch && filenameMatch.length === 2) {
        fileName = filenameMatch[1];
      }
    }
    const url = URL.createObjectURL(this.base64ToBlob(base64File, type));
    this.downloadFile(url, fileName + fileExtension);
  }

  /**
   * Scarica un blob, cercando di estrarre il nome file dagli headers (content-disposition),
   * altrimenti usa fallbackFileName.
   * @param {Blob} blob
   * @param {Object} headers - headers della risposta http
   * @param {string} fallbackFileName - nome file di fallback
   * @param {string} fileExtension - estensione opzionale da aggiungere
   */
  static downloadBlobWithHeaders(
    blob,
    headers,
    fallbackFileName,
    fileExtension = ""
  ) {
    let fileName = fallbackFileName || "download";
    if (headers && headers["content-disposition"]) {
      const contentDisposition = headers["content-disposition"];
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (filenameMatch && filenameMatch.length === 2) {
        fileName = filenameMatch[1];
      }
    }
    const url = URL.createObjectURL(blob);
    this.downloadFile(url, fileName + fileExtension);
  }

  static downloadBlob(blob, fallbackFileName, fileExtension = "") {
    const url = URL.createObjectURL(blob);
    this.downloadFile(url, fallbackFileName + fileExtension);
  }

  static downloadFile(url, name) {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  static downloadFileFromUrl(url, name) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        this.downloadFile(url, name);
      });
  }
}
